export default "__VITE_ASSET__040b8a5c__"